import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import AddAttendance from "./AddAttendance";
import { deleteAttendance } from "./store/attendanceSlice";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const AttendanceTable = ({ data, loading }) => {
  const [selectedId, setSelectedId] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();

  const { successMessage, error } = useSelector(
    (state) => state.attendanceData
  );
  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
    }
    if (error) {
      toast.error(error);
    }
  }, [successMessage, error]);

  const handleDelete = (employeeId) => {
    dispatch(deleteAttendance(employeeId));
    setDeleteModalOpen(false);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => (
        <div className="table-avatar">
          {/* <Link to="/profile" className="avatar">
            <img alt="" src={record.image} />
          </Link> */}
          <Link to="/profile">{text}</Link>
        </div>
      ),
    },
    // {
    //   title: "Email",
    //   dataIndex: "email",
    // },

    {
      title: "Employee Code",
      dataIndex: "employee_code",
    },
    {
      title: "Month",
      dataIndex: "month",
    },
    {
      title: "Present Day",
      dataIndex: "present_day",
    },
    {
      title: "Absent Day",
      dataIndex: "absent_day",
    },
    {
      title: "Working Days",
      dataIndex: "working_days_applicable",
    },
    {
      title: "Paid Holiday",
      dataIndex: "paid_holiday",
    },
    {
      title: "PL Leave Addition",
      dataIndex: "leave_addition_pl",
    },
    {
      title: "CL Leave Addition",
      dataIndex: "leave_addition_cl",
    },
    {
      title: "Balance Leave",
      dataIndex: "balance_leave",
    },
    // {
    //   title: "Action",
    //   render: (text, record) => (
    //     <div className="dropdown dropdown-action text-start">
    //       <Link
    //         to="#"
    //         className="action-icon dropdown-toggle"
    //         data-bs-toggle="dropdown"
    //         aria-expanded="false"
    //       >
    //         <i className="material-icons">more_vert</i>
    //       </Link>
    //       <div className="dropdown-menu dropdown-menu-right">
    //         {/* <Link
    //           className="dropdown-item"
    //           to="#"
    //           data-bs-toggle="modal"
    //           data-bs-target="#edit_user"
    //         >
    //           <i className="fa fa-pencil m-r-5" /> Edit
    //         </Link> */}
    //         <Link
    //           className="dropdown-item"
    //           to="#"
    //           // data-bs-toggle="modal"
    //           data-bs-target="#delete"
    //           onClick={() => {
    //             setSelectedId(record.id);
    //             setDeleteModalOpen(true);
    //           }}
    //         >
    //           <i className="fa fa-trash m-r-5" /> Delete
    //         </Link>
    //       </div>
    //     </div>
    //   ),
    // },
    {
      title: "Action",
      render: (text, record) => (
        <div className="text-start">
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id={`tooltip-delete-${record.id}`}>Delete</Tooltip>
            }
          >
            <Link
              className="btn btn-icon btn-danger btn-sm"
              to="#"
              onClick={() => {
                setSelectedId(record.id);
                setDeleteModalOpen(true);
              }}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                backgroundColor: "#e74c3c",
                color: "#fff",
                fontSize: "18px",
                border: "none",
              }}
            >
              <i className="fa fa-trash" />
            </Link>
          </OverlayTrigger>
        </div>
      ),
    },
  ];

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="table-responsive">
          <Table
            columns={columns}
            dataSource={data}
            loading={loading}
            rowKey="id"
            pagination={{
              pageSize: 10, // Keep a fixed number of items per page
              showSizeChanger: false, // Hide the "per page" dropdown
            }}
          />
          {isModalOpen && (
            <AddAttendance
              show={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              userId={selectedId}
            />
          )}

          {deleteModalOpen && (
            <DeleteModal
              onConfirm={() => handleDelete(selectedId)}
              onCancel={() => setDeleteModalOpen(false)}
              Name="Attendance"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AttendanceTable;
